import axios from 'axios';
import Vue from 'vue';

/**
 * The state for the brand portal which user has access to them. Each object key represent the handle of the brand portal.
 */
const state = () => ({
    countries: {}
});

const mutations = {
    /**
     * Add a list of countries to the state
     * @param {Object} state
     * @param {Object} countries
     * @param {Object} countries.code
     * @param {Object} countries.name
     */
    addCountries(state, countries) {
        Object.entries(countries).forEach(([code, name]) => {
            if (!state.countries[code]) {
                Vue.set(state.countries, code, name);
            }
        });
    }
};

const getters = {
    /**
     * Get a list of country codes
     * @param {Object} state
     * @returns {Array} List of country codes
     */
    getCountryCodes: (state) => Object.keys(state.countries),
    /**
     * Return the name of the given country code
     * @param {Object} state
     * @returns {Array} The name of the given country code
     */
    getCountryName: (state) => (countryCode) => state.countries[countryCode] ?? null
};

const actions = {
    /**
     * Load the list of countries
     * @param {Object} param0
     * @param {Object} param0.commit
     * @returns {Object} List of country codes => country names
     */
    async loadCountries({ commit }) {
        const { data } = await axios.get('/countries/list');
        if (data?.items) {
            commit('addCountries', data.items);
        }
        return data.items;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
